<template>
  <div>
    <!-- <h2>UserData</h2> -->
    <!-- <h6>{{ userData }}</h6> -->
    <vs-card>
      <div slot="header">
        <h3>
          {{ userData.name }}
        </h3>
      </div>
      <h5 class="mb-3">
        {{ userData.email }}
        </h5>
        <!-- <vs-chip v-if="userData.emailVerified" color="success">
        Verified
      </vs-chip>
      <vs-chip v-else color="danger">
        Not verified
      </vs-chip> -->   
      

      <hr />

      <div class="row mt-3">
        <h3 class="ml-3">Details</h3>

        <div class="vx-row m-0">
          <div class="vx-col md:w-1/2 w-full">
            <div class="vx-row mt-3">
              <div class="vx-col md:w-1/2 w-full ">
                <div class="details">
                  No. of courses watched
                </div>
              </div>
              <div class="vx-col md:w-1/2 w-full">
                <div class="details">
                  {{ userData.coursesWatched }}
                </div>
              </div>
            </div>
          </div>
          <div class="vx-col md:w-1/2 w-full"></div>
        </div>

        <div class="vx-row m-0">
          <div class="vx-col md:w-1/2 w-full">
            <div class="vx-row mt-3">
              <div class="vx-col md:w-1/2 w-full">
                <div class="details">
                  Duration watched
                </div>
              </div>
              <div class="vx-col md:w-1/2 w-full">
                <div class="details">
                  {{ userData.hoursWatched }}
                </div>
              </div>
            </div>
          </div>
          <div class="vx-col md:w-1/2 w-full"></div>
        </div>
      </div>
    </vs-card>

    
    <vs-card v-if="userData && userData.productsOrdered && userData.productsOrdered.length">
      <vs-table :data="userData && userData.productsOrdered">
        <template slot="header">
          <h3>
            Products Ordered
          </h3>
        </template>
        <template slot="thead">
          <vs-th >
            Product
          </vs-th>
          <vs-th sort-key="qty">
            Quantity
          </vs-th>
          <vs-th sort-key="date">
            Ordered Date
          </vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].product.name" v-if="data[indextr].product">
              {{ data[indextr].product.name }}
            </vs-td>

            <vs-td :data="data[indextr].product.qty" v-if="data[indextr].product">
              {{ data[indextr].product.qty }}
            </vs-td>

            <vs-td :data="data[indextr].orderDate">
              {{ new Date(data[indextr].orderDate).toLocaleString() }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-card>
    <vs-card>
      <vs-table v-if="userData && userData.coursesTaken" :data="userData.coursesTaken">
        <template slot="header">
          <h3>
            Courses Taken
          </h3>
        </template>
        <template slot="thead">
          <vs-th >
            Image
          </vs-th>
          <vs-th sort-key="course">
            Course
          </vs-th>
          <vs-th sort-key="duration">
            Duration
          </vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td class="img-container" :data="data[indextr].coverPage">
              <img :src="data[indextr].coverPage" class="product-img" />
            </vs-td>
            <vs-td :data="data[indextr].title">
              {{ data[indextr].title }}
            </vs-td>

            <vs-td :data="data[indextr].duration">
              {{ data[indextr].duration }}
            </vs-td>

          </vs-tr>
        </template>
      </vs-table>
    </vs-card>
  </div>
</template>

<script>
import moduleUsersreport from '@/store/usersReport/moduleUsersreport.js'

export default {
  props: ['userId'],
  
  computed: {
    userData () {
      return this.$store.state.usersReport.userData
    }
  },
  created () {
    if (!moduleUsersreport.isRegistered) {
      this.$store.registerModule('usersReport', moduleUsersreport)
      moduleUsersreport.isRegistered = true
    }
    // console.log('userId', this.$route.params.userId)
    this.$store.dispatch('usersReport/fetchUserData', this.$route.params.userId)
    
  }
  // mounted() {
  //   if (!moduleUsersreport.isRegistered) {
  //     this.$store.registerModule('usersReport', moduleUsersreport)
  //     moduleUsersreport.isRegistered = true
  //   }
  //   // console.log('userId', this.$route.params.userId)
  //   this.$store.dispatch('usersReport/fetchUserData', this.$route.params.userId)
  // }

}
</script>

<style scoped>
.details {
  font-size: 16px;
}

.badge {
  background-color: rgb(255, 251, 0);
}

.product-img {
  height: 110px;
}
</style>
